
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogCategoryFR]",
      function () {
        return require("private-next-pages/[...blogCategoryFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogCategoryFR]"])
      });
    }
  